import React, { useEffect, useState } from 'react';
import { AccountCreateScreen } from './AccountCreateScreen';
import { FamilyHome } from './FamilyHome';
import { ProfileDrawer } from './ProfileDrawer';
import { PurchaseScreen } from './PurchaseScreen';
import { SignInScreen } from './SignInScreen';
import { Lang } from '../../../lib/assets';
type View = 'home' | 'account' | 'signin' | 'subscribe';
type FamilyWebViewProps = {
  lang: Lang;
  isAuthenticated: boolean;
  openProfile?: boolean;
  onAuthenticated: () => void;
  onJoinProject: () => void;
  onProfileClosed: () => void;
  onSignOut: () => void;
};
export function FamilyWebView({
  lang: _lang,
  isAuthenticated,
  openProfile = false,
  onAuthenticated,
  onJoinProject,
  onProfileClosed,
  onSignOut
}: FamilyWebViewProps) {
  const [view, setView] = useState<View>('home');
  const [drawerOpen, setDrawerOpen] = useState(false);
  useEffect(() => {
    setDrawerOpen(openProfile && isAuthenticated);
  }, [isAuthenticated, openProfile]);
  const completeAccount = () => {
    onAuthenticated();
    setView('home');
  };
  return <div className="relative h-full overflow-hidden" data-id="element-247" data-mp="s4c5oxj5cfz4">
      {view === 'home' && <FamilyHome hasAccount={isAuthenticated} onCreateAccount={() => setView('account')} onSignIn={() => setView('signin')} onSubscribe={() => setView('subscribe')} onJoinProject={onJoinProject} onOpenMenu={() => setDrawerOpen(true)} data-id="element-248" data-mp="w8tpgwpiat9w" />}
      {view === 'account' && <AccountCreateScreen onBack={() => setView('home')} onMerged={completeAccount} data-id="element-249" data-mp="1ax6k9qcuy62t" />}
      {view === 'signin' && <SignInScreen onBack={() => setView('home')} onSignedIn={completeAccount} data-id="element-250" data-mp="1fvhtpzz8qeki" />}
      {view === 'subscribe' && isAuthenticated && <PurchaseScreen onBack={() => setView('home')} onConfirmed={() => setView('home')} data-id="element-251" data-mp="1jywcuzih7b26" />}
      {drawerOpen && <ProfileDrawer onClose={() => {
      setDrawerOpen(false);
      onProfileClosed();
    }} onSignOut={() => {
      setDrawerOpen(false);
      setView('home');
      onProfileClosed();
      onSignOut();
    }} data-id="element-252" data-mp="1ow60qaq7venw" />}
    </div>;
}